import { render, staticRenderFns } from "./tostButton.vue?vue&type=template&id=efe8b01a&scoped=true&"
import script from "./tostButton.vue?vue&type=script&lang=ts&"
export * from "./tostButton.vue?vue&type=script&lang=ts&"
import style0 from "./tostButton.vue?vue&type=style&index=0&id=efe8b01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe8b01a",
  null
  
)

export default component.exports